export default {
    confirm_delete_title: 'Are you sure you want to delete the instance "{0}"?',
    confirm_delete_body: "After deletion, the action will be irreversible.",
    table: {
        instance_name: "Instance Name",
        connected: "Connected",
        linked_users: "Linked Users",
        linked_branches: "Linked Branches",
        qr_code: "QR Code",
        delete_instance: "Delete Instance",
    },
    status: {
        connected: "Yes - {0}",
        disconnected: "No",
        replacing: "Replacing...",
        loading: "Loading...",
        connected_already: "Already connected",
    },
    buttons: {
        replace_error: "Error, replace instance",
        generate: "Generate",
        disconnect: "Disconnect",
        delete: "Delete",
        add: "Add Instance",
    },
    form: {
        placeholder_name: "Instance name",
    },
    notifications: {
        created: "New instance created",
        replaced: "Instance replaced",
        replace_error: "Error replacing instance",
        disconnected: "Instance disconnected",
        disconnect_error: "Error disconnecting instance",
        deleted: "Instance deleted",
        server_error: "Internal server error, try again later.",
    },
};
